/* ================================================== */
/* ACCESSIBILITY → Brand
/* ================================================== */

$(document).ready(function() {
	function accessibilityBrand() {
		var $brandLogo   = $('.brand__logo .brand__link'),
			$brandSticky = $('.brand__sticky .brand__link');
		if ($('#layout--header').hasClass('sticked')) {
			$brandLogo.attr('tabindex', '-1');
			$brandSticky.attr('tabindex', '0');
		} else {
			$brandLogo.attr('tabindex', '0');
			$brandSticky.attr('tabindex', '-1');
		}
	}

	accessibilityBrand();

	$(window).on('resize orientationchange', function() {
		accessibilityBrand();
	});

	$(window).scroll(function() {
		accessibilityBrand();
	});
});